
import eduImg from "../images/logos/education_logo_compressed.webp";
import dai from "../images/logos/dai_compressed.webp";
import google from "../images/logos/google.webp";
import IBM from "../images/logos/IBM.webp";
import Udacity from "../images/logos/udacity.webp";
import mod from "../images/logos/mod.webp";
import alx from "../images/logos/alx.webp";
import seaborn from "../images/logos/seaborn.webp";
import Plotly from "../images/logos/Plotly.webp";
import PowerBI from "../images/logos/PowerBI_compressed.webp";
import Tableau from "../images/logos/Tableau.webp";
import scikitLearn from "../images/logos/scikit-learn.webp";
import tensorFlow from "../images/logos/TensorFlow.webp";
import pyTorch from "../images/logos/PyTorch.webp";
import keras from "../images/logos/Keras.webp";
import mysqlLogo from "../images/logos/MySQL.webp";
import pythonLogo from "../images/logos/Python.webp";
import rLogo from "../images/logos/R.webp";
import excelLogo from "../images/logos/Excel.webp";
import sheetsLogo from "../images/logos/GoogleSheets.webp";
import pandasLogo from "../images/logos/Pandas.webp";
import numpyLogo from "../images/logos/NumPy_compressed.webp";
import colabLogo from "../images/logos/GoogleColab.webp";
import jupyterLogo from "../images/logos/Jupyter.webp";
import vscodeLogo from "../images/logos/VSCode.webp";
import githubLogo from "../images/logos/GitHub.webp";
import gitLogo from "../images/logos/Git.webp";
import dockerLogo from "../images/logos/docker.webp";
import salifortImg from "../images/project/salifort.webp";
import executiveSalesImg from "../images/project/executive_sales_dashboard.webp";
import wuzzufImg from "../images/project/wuzzuf.webp";
import resulensImg from "../images/project/resulens_ai.webp";
import vigilanceImg from "../images/project/vigilance_ai.webp";
import primeImg from "../images/project/prime.webp";
import watchtowerImg from "../images/project/watchtower.webp";


export const Bio = {
  name: "Ahmed Tarek",
  roles: [
    "Data Scientist & ML Engineer"
  ],

  description: "Data Scientist & Machine Learning Engineer with expertise in building end-to-end ML pipelines, from data wrangling to production deployment. Skilled in Python, SQL, TensorFlow, PyTorch, and cloud platforms. I specialize in developing predictive models, automating analytics workflows, and transforming complex data into actionable business insights.",
  github: "https://github.com/ahmedtarek-mel",
  resume: "https://drive.google.com/file/d/1C0JYPs-FezHkA0ylbmJ3wC6_XfTS7mDQ/view?usp=sharing",
  linkedin: "https://linkedin.com/in/ahmed-tarek-mel",
  Whatsapp: "https://api.whatsapp.com/send?phone=2001055200239",
  email: "mailto:ahmedtarekmel@gmail.com",
};


export const education = [
  {
    id: 0,
    img: eduImg,
    school: "MC",
    date: "Oct 2016 – May 2021",
    grade: "Good",
    desc: "BSc in Computer Science & AI. Studied Machine Learning, Probability & Statistics, Neural Networks, Data Visualization, and core CS subjects.",
    degree: "Bachelor of Computer Science & AI",
  },
  {
    id: 1,
    anchor: true,
    img: IBM,
    school: "IBM",
    date: "January 2026",
    grade: "Certified",
    desc: "Completed the 13-course IBM AI Engineering Professional Certificate covering machine learning, deep learning with Keras, PyTorch & TensorFlow, neural networks (CNNs, RNNs, Transformers), generative AI, LLMs, fine-tuning, and RAG applications with LangChain & Hugging Face.",
    degree: "IBM AI Engineering Professional Certificate",
  },

  {
    id: 2,
    img: dai,
    school: "DeepLearning.AI",
    date: "May 2025",
    grade: "Certified",
    desc: "Completed hands-on training on deploying ML models to production, optimizing model performance, monitoring ML pipelines, and solving challenges across structured, unstructured, small, and large-scale data.",
    degree: "Machine Learning in Production",
  },



  {
    id: 3,
    img: google,
    school: "Google",
    date: "February 2025",
    grade: "Certified",
    desc: "Completed the 7-course Google Advanced Data Analytics Specialization. Covered regression models, machine learning, data storytelling, statistics, Python programming, and advanced analytical techniques. Gained hands-on experience applying ML models, exploring large datasets, and communicating insights effectively.",
    degree: "Google Advanced Data Analytics",
  },

  {
    id: 4,
    img: IBM,
    school: "IBM",
    date: "September 2024",
    grade: "Certified",
    desc: "Completed the IBM Machine Learning Specialization, covering supervised and unsupervised ML, deep learning, reinforcement learning, regression and classification techniques, and exploratory data analysis. Gained hands-on experience building ML models, working with real-world datasets, optimizing performance, and deploying ML solutions.",
    degree: "IBM Machine Learning",
  },


  {
    id: 5,
    img: Udacity,
    school: "Udacity",
    date: "July 2022",
    grade: "Certified",
    desc: "Completed the MCIT-sponsored Nanodegree program focused on data analysis, statistics, data wrangling, data visualization, and practical analytical workflows using Python, NumPy, Pandas, and visualization libraries.",
    degree: "Data Analysis Professional Nanodegree",
  },


];



export const experiences = [
  {
    id: 0,
    img: mod,
    role: "Data Scientist",
    company: "MD",
    date: "Jun 2021 – Present",
    desc: "Developed and deployed end-to-end machine learning pipelines using Random Forest, Logistic Regression, and Neural Networks, improving decision-making accuracy by 30%. Automated analytics workflows with Python and Power BI, reducing manual reporting by 30% and improving operational efficiency by 20%. Performed advanced feature engineering, SQL-based data cleaning, and statistical modeling to support predictive analytics initiatives. Built reusable data pipelines that streamlined ML experimentation and enhanced model development efficiency.",
    skills: [
      "Python",
      "SQL",
      "Scikit-learn",
      "TensorFlow",
      "Feature Engineering",
      "Power BI",
      "Pandas",
      "Statistical Analysis",
      "Machine Learning"
    ]
  },

  {
    id: 1,
    img: alx,
    role: "Data Scientist (Internship)",
    company: "ALX Africa",
    date: "May 2023 – Oct 2024",
    desc: "Completed a 13-month intensive Data Science program covering statistical modeling, design thinking, SQL, spreadsheets, regression analysis, NLP, unsupervised learning, and AWS foundations. Built multiple real-world projects, including the GCGO team project and a full personal portfolio website. Participated in events, focus groups, and collaborative challenges that strengthened communication, analytical reasoning, and teamwork.",
    skills: [
      "Python",
      "SQL",
      "Machine Learning",
      "NLP",
      "Regression Analysis",
      "Unsupervised Learning",
      "AWS Foundations",
      "EDA",
      "Statistical Modeling"
    ]
  }
];



export const skills = [
  {
    title: "Visualization & BI",
    skills: [
      {
        name: "Power BI",
        image: PowerBI,
      },
      {
        name: "Tableau",
        image: Tableau,
      },
      {
        name: "Seaborn",
        image: seaborn,
      },
      {
        name: "Plotly",
        image: Plotly,
      },
    ],
  },

  {
    title: "ML & DL",
    skills: [
      { name: "Scikit-learn", image: scikitLearn },
      { name: "TensorFlow", image: tensorFlow },
      { name: "PyTorch", image: pyTorch },
      { name: "Keras", image: keras },
    ],
  },

  {
    title: "Data Processing & Analytics",
    skills: [

      {
        name: "MySQL",
        image: mysqlLogo,
      },
      {
        name: "Python",
        image: pythonLogo,
      },
      {
        name: "R",
        image: rLogo,
      },
      {
        name: "Excel",
        image: excelLogo,
      },
      {
        name: "Google Sheets",
        image: sheetsLogo,
      },
      {
        name: "Pandas",
        image: pandasLogo,
      },
      {
        name: "NumPy",
        image: numpyLogo,
      },
    ],
  },


  {
    title: "Development & Deployment",
    skills: [
      { name: "Google Colab", image: colabLogo },
      { name: "Jupyter", image: jupyterLogo },
      { name: "VS Code", image: vscodeLogo },
      { name: "GitHub", image: githubLogo },
      { name: "Git", image: gitLogo },
      { name: "Docker", image: dockerLogo },],
  },

];


export const projects = [
  {
    id: 0,
    title: "WatchTower - Network Intrusion Detection MLOps",
    description: "Production-ready MLOps pipeline for real-time network intrusion detection using state-of-the-art XGBoost (99.87% Accuracy) on CICIDS2017. Features full MLOps lifecycle including MLflow experiment tracking, Prefect orchestration, Great Expectations validation, and dockerized FastAPI serving with Prometheus monitoring.",
    image: watchtowerImg,
    tags: [
      "MLOps",
      "XGBoost",
      "FastAPI",
      "Docker",
      "MLflow",
      "Prefect",
    ],
    category: "MLOps",
    github: "https://github.com/ahmedtarek-mel/WatchTower",
    webapp: null,
  },
  {
    id: 1,
    title: "Prime Brief — AI Research & Executive Reports",
    description:
      "Multi-agent AI research platform leveraging CrewAI and Google Gemini to distill complex web research into actionable executive summaries. Features autonomous agents (Web Researcher, Content Summarizer, Email Coordinator), multiple report formats, real-time progress tracking, and automated email delivery with professional Streamlit UI.",
    image: primeImg,
    tags: [
      "CrewAI",
      "Google Gemini",
      "Multi-Agent AI",
      "Python",
      "Streamlit",
      "NLP",
      "Automation",
    ],
    category: "ML & DL",
    github: "https://github.com/ahmedtarek-mel/prime-brief",
    webapp: "https://prime-brief.streamlit.app/",
  },
  {
    id: 2,
    title: "Vigilance AI — Intelligent Driver Drowsiness Detection",
    description:
      "AI-powered driver drowsiness detection system using TensorFlow.js and Computer Vision. Features real-time Eye Aspect Ratio (EAR) and Mouth Aspect Ratio (MAR) analysis via MediaPipe Face Mesh, dynamic drowsiness scoring, visual & audio alerts, interactive dashboard with live charts, and dual architecture (Web + Python). Runs entirely in-browser for privacy.",
    image: vigilanceImg,
    tags: [
      "TensorFlow.js",
      "Computer Vision",
      "MediaPipe",
      "Python",
      "OpenCV",
      "Real-Time AI",
      "Deep Learning",
    ],
    category: "ML & DL",
    github: "https://github.com/ahmedtarek-mel/Vigilance-AI",
    webapp: "https://ahmedtarek-mel.github.io/Vigilance-AI/web",
  },
  {
    id: 3,
    title: "ResuLens AI — Intelligent Resume-to-Job Matching",
    description:
      "AI-powered resume analysis platform using NLP & Machine Learning that goes beyond keyword matching. Features BERT-powered semantic matching with Sentence-Transformers, smart skill extraction from a 500+ skill taxonomy, TF-IDF based ATS compatibility scoring, interactive radar charts, configurable scoring weights, and PDF report export.",
    image: resulensImg,
    tags: [
      "Python",
      "Flask",
      "NLP",
      "Sentence-Transformers",
      "TF-IDF",
      "Plotly",
      "Machine Learning",
    ],
    category: "ML & DL",
    github: "https://github.com/ahmedtarek-mel/ResuLens-AI",
    webapp: "https://resulens-ai.onrender.com",
  },
  {
    id: 4,
    title: "Wuzzuf Market Pulse — Real-Time Job Analytics Platform",
    description:
      "A production-grade automated data pipeline that scrapes, cleans, and visualizes Egyptian tech job market data in real-time. Features a custom ETL engine with GitHub Actions CI/CD for daily automated data updates, delivering actionable market intelligence through an interactive Streamlit dashboard.",
    image: wuzzufImg,
    tags: [
      "Python",
      "Streamlit",
      "Pandas",
      "Plotly",
      "Web Scraping",
      "ETL Pipeline",
      "CI/CD",
      "GitHub Actions",
    ],
    category: ["Visualization & BI", "Data Wrangling"],
    github: "https://github.com/ahmedtarek-mel/Wuzzuf-Job-Market-Analysis",
    webapp: "https://wuzzuf-job-market-analysis.streamlit.app/",
  },

  {
    id: 5,
    title: "Executive Sales Dashboard — Power BI",
    description:
      "An executive-level Power BI dashboard designed to analyze sales performance across multiple years. The dashboard provides clear KPIs, revenue trends, and category-level insights to support data-driven decision-making.",
    image: executiveSalesImg,
    tags: [
      "Power BI",
      "DAX",
      "Data Modeling",
      "Business Intelligence",
      "Sales Analytics",
      "Time Series Analysis",
    ],
    category: "Visualization & BI",
    github: "https://github.com/ahmedtarek-mel/executive-sales-dashboard-powerbi",
    webapp: null,
  },

  {
    id: 6,
    title: "Salifort Motors – Employee Turnover Prediction",
    description:
      "End-to-end HR analytics project focused on predicting employee turnover using machine learning. The project covers data cleaning, EDA, feature engineering, model training, evaluation, and business-driven insights to support HR decision-making.",
    image: salifortImg,
    tags: [
      "Python",
      "Pandas",
      "EDA",
      "Machine Learning",
      "Random Forest",
      "Scikit-learn",
    ],
    category: "ML & DL",
    github: "https://github.com/ahmedtarek-mel/Salifort-Motors-Turnover-Analysis",
    webapp: null,
  },
];





